module.exports = __webpack_public_path__ + "img/phone.95be70f0.png";